import MuseaNewLogo from '../../images/MUSEA_Logo_2026.png'

const Heading = ({ title, withBrandName }) => (
  <div className="div-block-5">
    <img src={MuseaNewLogo} loading="lazy" alt="MuseaLab" className="image-66" />
    <h1 className="heading-6">
      {title && `${title} `}
      {withBrandName && (
        <>
          <span className="text-span-3">MUSEA</span>
        </>
      )}
    </h1>
  </div>
)

export default Heading
